export const heading = "Open orders by In Hands Date";
export const completeListLink = "quadreport4";
